import { render, staticRenderFns } from "./BannerSwiper.vue?vue&type=template&id=b11bd29c&"
import script from "./BannerSwiper.vue?vue&type=script&lang=ts&"
export * from "./BannerSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./BannerSwiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports